import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';
import { PrimarySolidLink } from '@bibliocommons/base-links';

import './LinkContentRow.scss';

export default function LinkContentRow({ row, trackClick }) {
  const title = row.getIn(['config', 'title']);
  const links = row.getIn(['config', 'links']);

  function renderLinks(link, index) {
    const itemPosition = index + 1; // 1-based count for analytics
    const linkText = link.get('title');
    const linkUrl = link.get('url');

    return (
      <li className="link-content" key={linkText}>
        <PrimarySolidLink
          handleClick={() => trackClick({ itemPosition, linkText, linkUrl })}
          href={linkUrl}
          dataKey="link-primary"
          className="link-primary"
          size="large"
        >
          {linkText}
        </PrimarySolidLink>
      </li>
    );
  }

  return (
    <div className="cp-link-row">
      <Heading tagName="h2" size="moderate" variant>
        <span>{title}</span>
      </Heading>
      <ul className="link-row-contents">{links.map(renderLinks)}</ul>
    </div>
  );
}

LinkContentRow.propTypes = {
  row: ImmutablePropTypes.map.isRequired,
  trackClick: PropTypes.func.isRequired
};
